// src/views/Settings/org/OrgMembersSection.jsx
import React from 'react';
import GlassPanel from '../../../components/ui/GlassPanel';
import OrganizationMembers from './OrganizationMembers';

export default function OrgMembersSection({ organization, role }) {
  return (
    <GlassPanel className="p-8">
      <OrganizationMembers
        organizationId={organization.id}
        organizationName={organization.name}
        currentUserRole={role}
        onClose={() => {}}
      />
    </GlassPanel>
  );
}
